import { render, staticRenderFns } from "./workItem.vue?vue&type=template&id=6975a43e&scoped=true&"
import script from "./workItem.vue?vue&type=script&lang=js&"
export * from "./workItem.vue?vue&type=script&lang=js&"
import style0 from "./workItem.vue?vue&type=style&index=0&id=6975a43e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6975a43e",
  null
  
)

export default component.exports